/* src/pages/ITConsulting.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import itConsultingImage from "../assets/Images/it-consulting.jpg";

function ITConsulting() {
  const faqs = [
    {
      question: "What is IT consulting?",
      answer:
        "It's basically getting advice on your tech setup. I look at what you have, figure out what's working (and what's not), and help you make smart decisions about upgrades, security, or new systems.",
    },
    {
      question: "What do you help with?",
      answer:
        "System upgrades, network improvements, security setup, cloud migration - whatever makes sense for your business. I focus on practical stuff that actually helps, not fancy tech you don't need.",
    },
    {
      question: "How does it work?",
      answer:
        "Simple: I come take a look at your current setup, we talk about what problems you're having or what you want to accomplish, and I give you honest advice on the best path forward. No pressure to buy anything.",
    },
  ];

  return (
    <PageSection title="IT Consulting" cta faqs={faqs}>
      <Helmet>
        <title>IT Consulting Services | Tharpe Industries</title>
        <meta
          name="description"
          content="Strategic planning and implementation of IT systems to meet your business goals. Expert IT consulting services to enhance efficiency and drive growth."
        />
      </Helmet>
      <div className={styles.pageSection}>
        <img
          src={itConsultingImage}
          alt="IT Consulting"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <p>
            Not sure if your tech setup is holding you back? Need advice on upgrades, security, or switching to the cloud? 
            I help local businesses make smart IT decisions without the sales pitch or confusing jargon.
          </p>
          <p>
            Think of it like having a tech-savvy friend who actually knows what they're talking about. I'll look at what 
            you've got, tell you what makes sense (and what doesn't), and help you avoid expensive mistakes. No pressure 
            to buy anything you don't need.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default ITConsulting;
